
import React, { memo } from 'react';

interface CountdownTimerProps {
  className?: string;
}

const CountdownTimer: React.FC<CountdownTimerProps> = memo(({ className }) => {
  return (
    <div className={`inline-block bg-krix-purple/10 text-krix-purple text-sm font-medium rounded-full px-4 py-1 ${className}`}>
      🚀 Launch Special Offer
    </div>
  );
});

CountdownTimer.displayName = 'CountdownTimer';

export default CountdownTimer;
